import { get, put, post } from "lib/api";

let WORK_ORDERS_DEBUG = true;
export const setWorkOrdersDebug = (value) => { WORK_ORDERS_DEBUG = !!value; };
const wlog = (...args) => { if (WORK_ORDERS_DEBUG) console.log("[workOrders]", ...args); };

// Close a work order server-side:
// - Validates build completion
// - Ensures any inventory order is fulfilled (issued)
// - Produces finished goods into stock
// - Marks work order status to 'complete'
export async function closeWorkOrder(workOrderIdOrDocId) {
  const woRef = workOrderIdOrDocId;
  wlog("closeWorkOrder called with:", woRef);
  const res = await post(`/api/work-orders/${woRef}/close`);
  // backend returns { ok: true } on success
  const payload = res?.data || res;
  return payload?.ok === false ? payload : { ok: true, data: payload?.data || null };
}

export async function closeCompletedBatch(workOrderIdOrDocId) {
  const woRef = workOrderIdOrDocId;
  const res = await post(`/api/work-orders/${woRef}/close-completed-batch`, {});
  return res?.data || res;
}

export async function fetchBuildabilitySummary(workOrderIdOrDocId) {
  const woRef = workOrderIdOrDocId;
  const res = await post(`/api/work-orders/${woRef}/buildability-summary`, {});
  return (res?.data || res)?.data || res?.data || res;
}

// Backward compatibility (older pages still import this name).
export async function closeWorkOrderClientSide(workOrderIdOrDocId) {
  wlog("closeWorkOrderClientSide is deprecated; using server-side close instead");
  return closeWorkOrder(workOrderIdOrDocId);
}

